import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '@services/app.common.service';
import { RoleAccessService } from '@services/role.access.service';
import { SecurityRoleItems } from '../../_enums/securityRoleItems';
import { ClientConfiguation } from '../../_enums/clientConfiguration';
import { ApiUrls } from '../../_enums/apiUrls';
import { StatusCode } from '../../_enums/Common';
import { UserInfo } from '../../_models/common/userInfo';

@Component({
  selector: 'app-talent-pool-header-menu',
  templateUrl: './talent-pool-header-menu.component.html'
})
export class TalentPoolHeaderMenuComponent implements OnInit {
  @Output() byClickOnMenu = new EventEmitter<any>();
  isFeatureCRM: boolean = false;
  isTalentPoolAllowed = false;
  isTalentCaptureAllowed = false;
  isTalentCommunityAllowed = false;
  isFeatureRedeployment: boolean = false;
  isUserRedeploymentManager: boolean = false;
  isRedeploymentCase: boolean = false;
  public userInfo = {} as UserInfo;
  constructor(public common: CommonService, public roleService: RoleAccessService) { }

  ngOnInit() {
    this.isFeatureCRM = (this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.FeatureCRM)) && this.roleService.HasAccess(SecurityRoleItems.TalentPool));
    this.isTalentPoolAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentPool);
    this.isTalentCaptureAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentCapture);
    this.isTalentCommunityAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentCommunity);
    this.isRedeploymentCase = this.roleService.HasAccess(SecurityRoleItems.RedeploymentCases);
    this.isFeatureRedeployment = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.featureRedeployment));
    this.userInfo = this.common.GetLoggedinUserInfo()
  }
  navigateToMenu(index: string, path: string) {
    this.byClickOnMenu.emit({ index, path });
  }


}



